import { put, select, takeEvery } from 'redux-saga/effects';

import { MARK_ACTIVITY } from './druid/actions/markActivity';
import { of as activitiesOf } from './druid/selectors/activities';
import { SET_DICTATE_STATE } from './druid/actions/setDictateState';
import { WILL_START } from './druid/constants/DictateState';
import dictateStateSelector from './druid/selectors/dictateState';
import speakingActivity from './druid/definitions/speakingActivity';
import startDictate from './druid/actions/startDictate';

function* startDictateOnSpeakComplete() {
  const speakingActivities = yield select(activitiesOf(speakingActivity));
  const dictateState = yield select(dictateStateSelector);

  if (dictateState === WILL_START && !speakingActivities.length) {
    yield put(startDictate());
  }
}

// TODO: [P4] We should turn this into a reducer instead
export default function* startDictateOnSpeakCompleteSaga() {
  yield takeEvery(({ type }) => type === MARK_ACTIVITY || type === SET_DICTATE_STATE, startDictateOnSpeakComplete);
}
